import { Motor } from "./Motor";

export class Actuator {
  public constructor(){
    this.Name = "";
    this.Motors = [];
    this.FeedbackCode = "";
    this.Brake = false;

    this.RowPointer = "";
    this.CreateDate = new Date();
    this.RecordDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
  }
  
  public Name: string;
  public Motors: Motor[];
  public FeedbackCode: string;
  public Brake: boolean;




  //Syteline fields
  public RowPointer: string;
  public CreateDate: Date;
  public RecordDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
}
